$(document).ready(function() {
	// LGECS-240, LGEITF-438 : zendesk에서 받은 걸로 전체 변경
	var zen_info = $('.zendesk-area');
    var department = zen_info.data('dept');
    var greeting = zen_info.data('greeting');
    var offline_ment = zen_info.data('offlinement');
	
	
		setTimeout(function(){
        	window.zE('webWidget', 'setLocale', zen_info.data("locale"));
        	
        	var zen_departments = zE('webWidget:get', 'chat:departments');
            if (typeof zen_departments != 'undefined' && zen_departments.length > 0) {	//LGCOMITF-52
            	
            	var zendept = zen_departments.find(function( element){
            		if( element.name == department){
            			return true;
            		}
            	});
            	
            	
            	if (zendept != null && zendept.name == department && zendept.status == 'online') {
                    zE('webWidget', 'updateSettings', {
                        webWidget: {
                            chat: {
                                departments: {
                                    enabled: [department],
                                    select: department
                                },
                                prechatForm: {
                                    greeting: {
                                        '*': greeting
                                    }
                                },
                                suppress: false
                            }
                        }
                    });
                    zE('webWidget', 'show');
                } else {
                    zE('webWidget', 'updateSettings', {
                        webWidget: {
                            chat: {
                                departments: {
                                    enabled: [],
                                    select: department
                                },
                                prechatForm: {
                                    greeting: {
                                        '*': offline_ment
                                    }
                                },
                                suppress: true
                            }
                        }
                    });
                }
            }
			
			window.zE('webWidget:on', 'open', function() {
			    //console.log('The widget has been opened!');
			    adobeTrackEvent('cs-lg-chatbot-start-btn', {page_event : {start_lg_chatbot : true}});
			});
			window.zE('webWidget:on', 'chat:departmentStatus', function(dept) {
				//console.log(zen_info.data("dept")+' dept : ' + dept.name + " = "+dept.status); 
				if (dept.name == department && dept.status == 'online') {
					//console.log(dept.name + ' is online : ' + dept.status);      //optional logging
					zE('webWidget', 'updateSettings', {
						webWidget: {
							chat: {
								departments: {
									enabled: [dept.name],
									select: dept.name  
								},
								prechatForm: {
									greeting : {
										'*' : greeting
									}
								},
								suppress: false
							}
						}
					});
				}
				else if (dept.name == department && dept.status !== 'online') {
					//console.log(dept.name + ' is offline : ' + dept.status);      //optional logging
					zE('webWidget', 'updateSettings', {
						webWidget: {
							chat: {
								departments: {
                                    enabled: [],
                                    select: dept.name
                                },
                                prechatForm: {
                                    greeting: {
                                        '*': offline_ment
                                    }
                                },
                                suppress: true
							}
						}
					});
				}
			});
        },3000);
	
});